module.exports = __webpack_public_path__ + "assets/f66f6acc12c5968ad09d110f79787d51.mp4";